import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface FrequencyAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant?: OD3_Tenant;
  ticket: Ticket;
  user?: _User;
  value: number;
}

export class Frequency extends Parse.Object<FrequencyAttributes> {
  static className: string = "OD3_Maintenance_Frequency";

  constructor(data?: Partial<FrequencyAttributes>) {
    super("OD3_Maintenance_Frequency", data as FrequencyAttributes);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket {
    return super.get("ticket");
  }
  set ticket(value: Ticket) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Frequency", Frequency);
